exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-58ce4c40],.fade-leave-active[data-v-58ce4c40]{　　　　transition:all .2s linear;　　　　transform:translate3D(0,0,0)}.fade-enter[data-v-58ce4c40],.fade-leave-active[data-v-58ce4c40]{　　　　transform:translate3D(100%,0,0)}.img-view[data-v-58ce4c40]{　　　　position:inherit;　　　　width:100%;　　　　height:100%}.img-view .img-layer[data-v-58ce4c40]{　　　　position:fixed;　　　　z-index:999;　　　　top:0;　　　　left:0;　　　　background:rgba(0,0,0,.7);　　　　width:100%;　　　　height:100%;　　　　overflow:hidden}.img-view .img img[data-v-58ce4c40]{　　　　max-width:100%;　　　　display:block;　　　　position:absolute;　　　　left:0;　　　　right:0;　　　　margin:auto;　　　　z-index:1000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58ce4c40","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/comn/BigImg.vue
// module id = 1757
// module chunks = 1